import React, {Component} from 'react';
import Skeleton from 'react-loading-skeleton';
import {Container} from "reactstrap";
import assets from "../../../util/assets";
import "./index.css"
import EmptyComponent from "../../../components/empty";
import {connect} from "react-redux";
import * as actions from "../../../actions";
import library from "../../../util/clipstore/broadcaster/library";
import api from "../../../util/clipstore/user/subscription_api";
import SubscriptionListItem from "../../../components/clipstore/user/profile/subscriptions";

const getListArray = (props) => {
    return (
        props.get_subscription_list &&
        props.get_subscription_list.hasOwnProperty("payload") &&
        props.get_subscription_list.payload &&
        props.get_subscription_list.payload.hasOwnProperty("success") &&
        props.get_subscription_list.payload.success.hasOwnProperty("data") &&
        Array.isArray(props.get_subscription_list.payload.success.data) &&
        props.get_subscription_list.payload.success.data.length > 0
    )
}

class UserSubscriptionContainer extends Component {

    constructor() {
        super();
    }

    componentDidMount() {
        api.getSubscriptionListAPI(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        library.handleAPIResponse(nextProps, "get_subscription_list", () => {

        }, () => {
        }, () => {

        }, true, true);

        library.handleAPIResponse(nextProps, "cancel_subscription", () => {

        }, () => {
            api.getSubscriptionListAPI(this.props);
            this.props.resetCancelSubscription();
        }, () => {

        });

        library.handleAPIResponse(nextProps, "renew_subscription", () => {

        }, () => {
            api.getSubscriptionListAPI(this.props);
            this.props.resetRenewSubscription();
        }, () => {

        });
    }

    cancelSubscription = (id)=>{
        api.cancelSubscriptionAPI(this.props,id)
    }

    renewSubscription = (id)=>{
        api.renewSubscriptionAPI(this.props,id)
    }

    render() {

        if (this.props.get_subscription_list.isFetching) {
            return (
                <Container className="user-profile-subscription-container">
                    {
                        [1, 2, 3, 4, 5].map((value,index) => {
                            return (
                                <div style={{background:'#f7f7f7'}} key={`subscription-list-item-${index}`}>
                                    <Skeleton style={{height: 88, marginBottom: 8}}/>
                                </div>
                            )
                        })
                    }
                </Container>
            );
        } else if (getListArray(this.props)) {
            return (
                <Container className="user-profile-subscription-container">
                    {
                        this.props.get_subscription_list.payload.success.data.map((item, index) => {
                            return (
                                <SubscriptionListItem
                                    history={this.props.history}
                                    cancelSubscription={this.cancelSubscription}
                                    renewSubscription={this.renewSubscription}
                                    cancel_subscription={this.props.cancel_subscription}
                                    renew_subscription={this.props.renew_subscription}
                                    key={`subscription-list-item-${index}`}
                                    item={item}/>
                            )
                        })
                    }
                </Container>
            );
        } else {
            return (
                <Container>
                    <EmptyComponent
                        img={assets.empty.content_zero}
                        title={" No subscription found"}
                        description={"Sorry there is no subscription found at this moment. Try subscribing to a broadcaster and try again."}/>
                </Container>
            );
        }

    }
}

function mapStateToProps(state, ownParams) {
    return {
        device: state.device.payload,
        get_subscription_list: state.get_subscription_list,
        cancel_subscription: state.cancel_subscription,
        renew_subscription: state.renew_subscription,
    };
}

export default connect(mapStateToProps, actions)(UserSubscriptionContainer);
